import { AreasManagerGet } from "#core/Services/api_areas"
import { useApi } from "#hooks/useApi"
import AnnualPlanCreateAreas from "#training/components/annual-plan-create/AnnualPlanCreateAreas"
import { AnnualPlanCreateProvider } from "#training/contexts/AnnualPlanCreateContext"
import { Box, Paper, Skeleton, Typography } from "@mui/material"
import { useMemo, useState } from "react"

export default function AnnualPlanCreate() {
	const [reload, setReload] = useState(true)
	const params = useMemo(() => ({ annual_plan: true }), [])
	const { data, loading } = useApi(AreasManagerGet, { autoFetch: true, params, reload })

	if (loading) return <Skeleton variant="rectangular" height={"77vh"} />

	if (!data?.count)
		return (
			<Box component={Paper} width={"100%"} minHeight={"77vh"} sx={{ p: 2 }}>
				<Typography textAlign="center" paddingTop={"10vh"} variant="h3">
					No Tienes departamentos a tu cargo
				</Typography>
			</Box>
		)

	return (
		<Box width={"100%"} minHeight={"77vh"}>
			<AnnualPlanCreateProvider
				areas={data.areas}
				reload={reload}
				setReload={setReload}
			>
				<AnnualPlanCreateAreas />
			</AnnualPlanCreateProvider>
		</Box>
	)
}
